var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MMCard',{attrs:{"title":"ToDo"}},[_c('template',{slot:"content"},[_c('audio',{attrs:{"controls":"controls"}},[_c('source',{attrs:{"src":_vm.musicSrc,"type":"audio/mp3"}})])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }